import React from "react";

import { Button, Container } from "react-bootstrap";

import './HeaderHomePage.css';

function HeaderHomePage() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <div>
      <div
        style={{
          backgroundImage: "url(" + require("../../../../assets/img/jumbo.png") + ")"
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="filter" />
        <Container>
          <div className="motto text-center">
            <h1 className="jumbo-center-title">Lana Hill</h1>
            <h3 className="jumbo-center-text">The Website of the Stylist</h3>
            <br />
            <Button 
              id="btn-quick-start"
              className="btn-round"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                window.location.href='#contact-form';
              }}
            >
              TAKE AN APPOINTMENT
            </Button>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default HeaderHomePage;
